var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`r-title ${_vm.type} ${_vm.colorType}`, { center: _vm.center }],style:(_vm.getStyle())},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }